<template>
  <div class="tcla-action-plan">
    <div class="tcla-panel">
      <h3 class="tcla-panel__title">🤖 دستیار سئو — اول چه کاری انجام بدم؟</h3>
      <p class="tcla-panel__hint">
        صفحات بر اساس فوریت مرتب شده‌اند: امتیاز سئوی پایین‌تر + کلمه کلیدی
        دقیق‌تر (طولانی‌تر) = اولویت بالاتر، چون معمولاً سریع‌تر نتیجه می‌دهد.
      </p>
      <div v-if="contentPlan.length === 0" class="tcla-empty">
        همه صفحات وضعیت خوبی دارند 🎉
      </div>
      <div v-for="(page, idx) in contentPlan" :key="page.url" class="tcla-plan-card">
        <div class="tcla-plan-card__head">
          <div class="tcla-plan-card__rank">#{{ idx + 1 }}</div>
          <div class="tcla-plan-card__info">
            <strong>{{ page.title }}</strong>
            <div class="tcla-plan-card__meta">
              <span class="tcla-score-pill" :class="scoreClass(page.seoScore)">امتیاز فعلی: {{ page.seoScore }}</span>
              <span v-if="page.keywordSpecificity >= 3" class="tcla-tag tcla-tag--green">
                کلمه کلیدی {{ page.keywordSpecificity }} تایی — برد سریع 🎯
              </span>
              <span v-if="page.isHub" class="tcla-tag tcla-tag--blue">صفحه Hub</span>
            </div>
          </div>
          <button class="tcla-btn" @click="$emit('edit-blog', page.source)">ویرایش</button>
        </div>

        <div class="tcla-plan-card__actions">
          <div class="tcla-plan-card__actions-title">اقدامات پیشنهادی (به ترتیب):</div>
          <div v-for="(action, aIdx) in page.actions" :key="aIdx" class="tcla-action-item">
            <span class="tcla-action-item__num">{{ aIdx + 1 }}</span>
            <span class="tcla-action-item__icon">{{ action.icon }}</span>
            <span class="tcla-action-item__text">{{ action.text }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="tcla-panel">
      <h3 class="tcla-panel__title">🔗 برنامه لینک‌سازی (به ترتیب اولویت)</h3>
      <p class="tcla-panel__hint">
        اول لینک‌های ساختاری (Hub/والد) را اضافه کنید — چون بیشترین ارزش لینک
        را منتقل می‌کنند — بعد سراغ لینک‌های محتوایی بروید.
      </p>
      <div v-if="linkBuildingPlan.length === 0" class="tcla-empty">فرصت لینک‌سازی جدیدی یافت نشد</div>
      <div v-for="(link, idx) in linkBuildingPlan" :key="idx" class="tcla-link-step">
        <span class="tcla-link-step__num">{{ idx + 1 }}</span>
        <div class="tcla-link-step__body">
          <div class="tcla-link-step__titles">
            <strong>{{ link.sourceTitle }}</strong>
            <span class="tcla-arrow">←</span>
            <strong>{{ link.targetTitle }}</strong>
          </div>
          <div class="tcla-link-step__reason">{{ link.reason }}</div>
        </div>
        <span class="tcla-tag" :class="stepBadgeClass(link.type)">{{ stepLabel(link.type) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TCLAActionPlan',
  props: {
    contentPlan: { type: Array, default: () => [] },
    linkBuildingPlan: { type: Array, default: () => [] }
  },
  methods: {
    scoreClass(score) {
      if (score >= 70) return 'tcla-score--good';
      if (score >= 40) return 'tcla-score--mid';
      return 'tcla-score--bad';
    },
    stepLabel(type) {
      return {
        missingHub: 'لینک به Hub',
        missingParent: 'لینک به والد',
        missingChild: 'لینک هاب به فرزند',
        missingSibling: 'لینک خواهر/برادر',
        missingContextual: 'لینک محتوایی'
      }[type] || type;
    },
    stepBadgeClass(type) {
      if (type === 'missingHub' || type === 'missingParent' || type === 'missingChild') return 'tcla-tag--err';
      if (type === 'missingSibling') return 'tcla-tag--warn';
      return 'tcla-tag--blue';
    }
  }
};
</script>

<style scoped>
.tcla-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 20px;
  margin-bottom: 16px;
}

.tcla-panel__title { font-size: 0.95rem; font-weight: 700; margin: 0 0 8px 0; }
.tcla-panel__hint {
  font-size: 0.78rem;
  color: #9ca3af;
  line-height: 1.5;
  margin: 0 0 16px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
}
.tcla-empty { text-align: center; padding: 20px; color: #9ca3af; }

.tcla-plan-card {
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 16px;
  background: #f9fafb;
  margin-bottom: 14px;
}

.tcla-plan-card__head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.tcla-plan-card__rank {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #3b82f6;
  color: #fff;
  font-weight: 700;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tcla-plan-card__info { flex: 1; min-width: 0; }
.tcla-plan-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.tcla-plan-card__actions {
  padding-top: 12px;
  border-top: 1px dashed #d1d5db;
}

.tcla-plan-card__actions-title {
  font-size: 0.75rem;
  font-weight: 700;
  color: #6b7280;
  margin-bottom: 8px;
}

.tcla-action-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 0;
  font-size: 0.82rem;
  line-height: 1.5;
}

.tcla-action-item__num {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #4b5563;
  font-size: 0.65rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}

.tcla-action-item__icon { flex-shrink: 0; }
.tcla-action-item__text { color: #374151; }

.tcla-link-step {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  margin-bottom: 10px;
  background: #f9fafb;
}

.tcla-link-step__num {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #4b5563;
  font-size: 0.7rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tcla-link-step__body { flex: 1; min-width: 0; }
.tcla-link-step__titles {
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.tcla-arrow { color: #9ca3af; }
.tcla-link-step__reason {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 4px;
}

.tcla-score-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 100px;
  font-weight: 700;
  font-size: 0.72rem;
}
.tcla-score--good { background: #d1fae5; color: #16a34a; }
.tcla-score--mid { background: #fef3c7; color: #d97706; }
.tcla-score--bad { background: #fee2e2; color: #ef4444; }

.tcla-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  flex-shrink: 0;
}
.tcla-tag--blue { background: #dbeafe; color: #3b82f6; }
.tcla-tag--green { background: #dcfce7; color: #16a34a; }
.tcla-tag--err { background: #fee2e2; color: #ef4444; }
.tcla-tag--warn { background: #fef3c7; color: #d97706; }

.tcla-btn {
  padding: 6px 12px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.8rem;
  cursor: pointer;
  flex-shrink: 0;
}
.tcla-btn:hover { background: #f3f4f6; }
</style>
